export default function () {
  return <div style={{ flex: '1', borderBottom: '1px dotted', margin: '0 8px' }}></div>
}